import React from 'react';
import styles from './KeyPeopleListItem.module.scss';
import { useTranslation } from 'react-i18next';
import { Divider } from '@Components/Divider/Divider';
import { Button } from '@Components/common';
import { StatusChip } from '@Components/StatusChip/StatusChip';
import { KeyPerson, KeyPersonRole } from '@Types/KeyPeople';
import { RiCheckLine } from 'react-icons/ri';

export interface KeyPeopleListItemProps {
  keyPerson: KeyPerson;
  keyPeopleRoles: KeyPersonRole[];
  setAddPeopleOpen: (addPeopleOpen: boolean) => void;
  setKeyPerson: (keyPerson: KeyPerson) => void;
}

export const KeyPeopleListItem = ({
  keyPerson,
  keyPeopleRoles,
  setAddPeopleOpen,
  setKeyPerson,
}: KeyPeopleListItemProps) => {
  const { t } = useTranslation('account');

  const hasRole = (roleName: string) => {
    // TS hates dynamic variables in this case it doesn't understand the type
    // so has to be explicit in defining it's a key type of the keyPerson object.
    type Key = keyof typeof keyPerson;
    const role = `is_${roleName.toLowerCase()}`;

    return keyPerson[role as Key];
  };

  const name = keyPerson.first_name + ' ' + keyPerson.last_name;
  return (
    <>
      <div className={styles.container}>
        <div className={styles.infoContainer}>
          <h3 className={styles.title}>{name}</h3>

          <div className={styles.rolesChipContainer}>
            {keyPeopleRoles.map((role) => (
              <StatusChip
                key={role.name}
                label={role.name}
                color={hasRole(role.name) ? 'primary' : 'secondary'}
                icon={hasRole(role.name) ? <RiCheckLine size={18} /> : undefined}
              />
            ))}
          </div>
        </div>
        <Button
          size="small"
          buttonType="secondary"
          onClick={() => {
            setKeyPerson(keyPerson);
            setAddPeopleOpen(true);
          }}
        >
          {t('edit')}
        </Button>
      </div>
      <Divider small />
    </>
  );
};
